import { render, staticRenderFns } from "./ChoiceFilter.vue?vue&type=template&id=9b2c977c&scoped=true&"
import script from "./ChoiceFilter.vue?vue&type=script&lang=js&"
export * from "./ChoiceFilter.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceFilter.vue?vue&type=style&index=0&id=9b2c977c&prod&lang=scss&scoped=true&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2c977c",
  null
  
)

export default component.exports